import withProps from 'recompose/withProps';
import MaskedInput from 'react-maskedinput';
import PlainInput from './PlainInput';


export default withProps({
  component: MaskedInput,
  mask: '+7 111 111 11 11',
})(PlainInput);
